<custom-upsell-form
  [formGroup]="formGroup"
  [restrictionsRules]="restrictionsRules"
  [entities]="entities"
  [shopCurrencySymbol]="shopCurrencySymbol"
  [shop$]="shop$"
  [shopService]="shopService"
  [loadedExtension]="loadedExtension"
  [updateRequired]="updateRequired"
  [updateAppUrl]="updateAppUrl"
  [productImageBase64]="productImageBase64"
  [customUpsellConfig]="customUpsellConfig"
  [upsellRateTypeConfig]="upsellRateTypeConfig"
  [applyDiscountToOptions]="applyDiscountToOptions"
  [PlacementMode]="PlacementMode"
  [camelCaseToTitleCase]="camelCaseToTitleCase"
  [formArrayFieldName]="formArrayFieldName"
  [onApplyDiscountToChange]="onApplyDiscountToChange"
  [onProductImageChange]="onProductImageChange"
  [clearImage]="clearImage"
  [onUpdateAppPermissions]="onUpdateAppPermissions"
  [onTimerConfigurationChange]="handleTimerConfigurationChange"
  #customUpsellForm></custom-upsell-form>
